import { z } from 'zod';
import { esquemaZonaHoraria } from './comunes.js';
/** Color en notacion hexadecimal de seis digitos. */
export const esquemaColor = z
    .string()
    .trim()
    .regex(/^#[0-9a-fA-F]{6}$/, 'Use un color hexadecimal, por ejemplo #0d6f6a');
/**
 * Identificador del consultorio en la URL publica de su agenda.
 * Sin acentos ni mayusculas, para que sea legible y estable.
 */
export const esquemaSlug = z
    .string()
    .trim()
    .toLowerCase()
    .min(3, 'Al menos 3 caracteres')
    .max(40, 'Máximo 40 caracteres')
    .regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/, 'Use minúsculas, números y guiones');
export const esquemaMembrete = z.object({
    direccion: z.string().trim().max(200).default(''),
    telefono: z.string().trim().max(40).default(''),
    web: z.string().trim().max(120).default(''),
    correo: z.union([z.literal(''), z.string().trim().email()]).default(''),
});
/**
 * Identidad visual y documental del consultorio.
 *
 * Es un dato de la organizacion, no configuracion del despliegue: en una misma
 * instancia conviven consultorios con marcas distintas.
 */
export const esquemaMarca = z.object({
    nombreComercial: z.string().trim().min(2).max(120),
    colorPrimario: esquemaColor.default('#0d6f6a'),
    colorSecundario: esquemaColor.default('#8a4b6d'),
    membrete: esquemaMembrete.default({}),
    pieDePagina: z.string().trim().max(300).default(''),
});
export const esquemaActualizarMarca = esquemaMarca.partial();
/**
 * Alta de un consultorio. Crea la organizacion y su primer usuario
 * (el propietario) en una sola operacion: un consultorio sin dueno no sirve
 * de nada, y dejarlo en dos pasos abre la puerta a organizaciones huerfanas.
 */
export const esquemaRegistroOrganizacion = z.object({
    organizacion: z.object({
        nombre: z.string().trim().min(2).max(120),
        slug: esquemaSlug,
        zonaHoraria: esquemaZonaHoraria.default('America/Mexico_City'),
    }),
    propietario: z.object({
        nombre: z.string().trim().min(2).max(120),
        correo: z.string().trim().toLowerCase().email(),
        contrasena: z
            .string()
            .min(12, 'Al menos 12 caracteres')
            .max(200)
            .refine((valor) => /[a-z]/.test(valor) && /[A-Z]/.test(valor) && /\d/.test(valor), {
            message: 'Incluya minúsculas, mayúsculas y al menos un número',
        }),
        cedulaProfesional: z.string().trim().min(4).max(30),
        especialidad: z.string().trim().max(120).default(''),
    }),
});
//# sourceMappingURL=organizacion.js.map